const data = {
     employees: [
          {
               slug: 'Ana Barbacuiro',
               name: 'Ana Barbacuiro',
               JobTitle: 'HR',
               email: 'anatest@yahoo.com',
               phoneNo: 'tel:+6508623411',
               image: '/images/stephenCUrry.jpg',
          },
          {
               slug: 'Henry chen',
               name: 'Henry chen',
               JobTitle: 'CFO',
               email: 'henrytest@yahoo.com',
               phoneNo: 'tel:+6508623401',
               image: '/images/p2.jpg',
          },
          {
               slug: 'Mike colzani',
               name: 'Mike colzani',
               JobTitle: 'President',
               email: 'miketest@yahoo.com',
               phoneNo: 'tel:+6508623412',
               image: '/images/p3.jpg',
          },
          {
               slug: 'Philip',
               name: 'Philip Maritnez',
               JobTitle: 'MailRoom & Web Developer',
               email: 'martinezphilip401@yahoo.com',
               phoneNo: 'tel:+6508623411',
               image: '/images/p3.jpg',
          },
          {
               slug: 'Herman Pooh',
               name: 'Herman Pooh',
               JobTitle: 'BigBoss',
               email: 'martinezphilip401@yahoo.com',
               phoneNo: 'tel:+4152156918',
               image: '/images/p4.jpg',
          },
     ],
};

export default data;
